import { render } from "./LightboxPosterComponent.vue?vue&type=template&id=15d22497&ts=true"
import script from "./LightboxPosterComponent.vue?vue&type=script&lang=ts"
export * from "./LightboxPosterComponent.vue?vue&type=script&lang=ts"

import "./LightboxPosterComponent.vue?vue&type=style&index=0&id=15d22497&lang=scss"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__